import { KeycloakInstance } from "keycloak-js";
import React from "react";

export type KeycloakState = {
  keycloak: KeycloakInstance;
  token: string;
  cityId: string;
  logout: Function;
  createAccountUrl: Function;
  authenticationService: any;
  login: Function;
  loggedIn?: boolean;
};

export const KeycloakContext = React.createContext<KeycloakState | undefined>(
  undefined
);

export default KeycloakContext;
